import { Fetch } from '.';
import { ContentTypeConfiguration } from '../types/ContentTypeConfiguration';

export const getContentTypeConfig =
  (f: Fetch) =>
  async (p: number): Promise<ContentTypeConfiguration> => {
    let query = `query {
        item(itemId: ${p}) {
          contentTypeConfig {
            ...ContentTypeConfigFields 
          }
        }
      }`;
    const r = await f.graphQLFetch<any>(
      process.env.CPP_CONTENT_URI + '/item',
      query
    );
    if (r) {
      let { contentTypeConfig } = r as any;
      return contentTypeConfig;
    }
    console.error('getContentTypeConfig', r);
    throw new Error('Failed to getContentTypeConfig');
  };
